// Legal Disclaimer Modal //

import MicroModal from "micromodal";

MicroModal.init({
  closeTrigger: "data-micromodal-close",
  openClass: "is-open",
});

function setCookie(cname: any, cvalue: any, exdays: any) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname: any): string {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

var cookie = getCookie("shown");
if (!cookie) {
  showPopup();
}

function showPopup() {
  document.addEventListener("DOMContentLoaded", function () {
    const opts = {
      disableFocus: true,
    };
    MicroModal.show("legal-disclaimer", opts);
  });
}

var acceptButton = document.getElementById("accepted");
acceptButton?.addEventListener("click", function (event) {
  setCookie("shown", "true", 30);
});

acceptButton?.addEventListener("touchstart", function (event) {
  setCookie("shown", "true", 30);
});

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    if (!cookie) {
      alert("Please click Accept to use this site.");
      event.stopImmediatePropagation();
    }
  }
});
